import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule} from '@angular/forms';

import { PipesModule } from './pipes.module';
import { LoginComponent } from 'app/components/login/login.component';
import { RouterModule, Routes } from '@angular/router';
import { ContainerComponent } from 'app/components/user/container.component';
import { AuthGuard } from 'app/guards/auth.guard';
import { BbTableModule } from './bb-table.module';
import { SharedModule } from './shared.module';
import { LoginFooterComponent } from 'app/components/login/login-footer.component';
import { LoginSidebarComponent } from 'app/components/login/login-sidebar.component';
import { LogoutComponent } from 'app/components/login/logout.component';

const loginModuleRoutes: Routes = [
	{
		path: 'login',
		canActivate: [AuthGuard],
		component: ContainerComponent,
		data: {component: 'login'},
		children: [
			{
				path: 'reset-password',
				component: ContainerComponent,
				data: {component: 'login'},
				pathMatch: 'full'
			},
			{
				path: ':tab',
				canActivate: [AuthGuard],
				component: ContainerComponent,
				data: {component: 'login'}
			}
		]
	},
	{
		path: 'logout',
		component: LogoutComponent
	}
];

@NgModule({
	imports: [
		RouterModule.forChild(loginModuleRoutes),
		CommonModule,
		SharedModule,
		PipesModule,
		FormsModule,
		BbTableModule
	],
	declarations: [
		LoginComponent,
		LoginFooterComponent,
		LoginSidebarComponent
	],
	exports: [
		LoginComponent,
		LoginFooterComponent,
		LoginSidebarComponent
	],
})
export class LoginModule {

}
